module.exports = __webpack_public_path__ + "static/media/ecommerce.c97011cd.jpg";